'use strict';

/* global $ */

let settings = {
    mainMenu: '.js-main-menu',
    mainMenuServices: '.js-main-menu__services',
    mainMenuServicesBlock: '.js-main-menu__services-block',
    mainMenuServicesClose: '.js-main-menu__services-close'
};

class MainMenu {
    constructor(options) {
        this.opt = $.extend({}, settings, options);
        this.init();
    }
    init() {
        console.log('[ MainMenu/init ]');

        let $mainMenu = $(this.opt.mainMenu);
        let $mainMenuServices = $(this.opt.mainMenuServices);
        let $mainMenuServicesBlock = $(this.opt.mainMenuServicesBlock);
        let $mainMenuServicesClose = $(this.opt.mainMenuServicesClose);
        $mainMenuServices.on('click', function(e) {
            e.preventDefault();
            $mainMenuServicesBlock.toggleClass('is-active');
            if ($mainMenuServicesBlock.hasClass('is-active')) {
                $mainMenuServices.addClass('is-active');
                $mainMenuServicesBlock.find('.js-nicescroll').getNiceScroll().show().resize();
            } else {
                $mainMenuServices.removeClass('is-active');
                $mainMenuServicesBlock.find('.js-nicescroll').getNiceScroll().hide().resize();
            }
        });

        $mainMenuServicesClose.on('click', function(e) {
            e.preventDefault();
            $mainMenuServicesBlock.removeClass('is-active');
            $mainMenuServices.removeClass('is-active');
            $mainMenuServicesBlock.find('.js-nicescroll').getNiceScroll().hide().resize();
        });
    }
}


export {
    MainMenu
};
